import { apiGet } from './ApiClient'

/**
 * Fetches the list of all office locations from EntraId
 */
export async function getOffices(): Promise<string[]> {
  return await apiGet<string[]>('/employees/offices')
}
